import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'
import { ReactNode, useEffect } from 'react'
import Monitor from './pages/Monitor'
// import History from './pages/History'  // TODO: 历史回放功能暂未完善
import AlarmCenter from './pages/AlarmCenter'
import Settings from './pages/Settings'
import VideoManagement from './pages/VideoManagement'
import Login from './pages/Login'
import AppHeader from './components/Layout/AppHeader'
import AppSider from './components/Layout/AppSider'
import { useUserStore, useUIStore } from './store/useDeviceStore'
import { get } from './utils/request'
import { useWebSocketLifecycle } from './hooks/useWebSocket'

const { Content } = Layout

function AppWebSocketManager() {
  const { token, userId, role, username } = useUserStore()

  useWebSocketLifecycle(token, userId, role, username)

  return null
}

/**
 * 路由保护组件
 *
 * 检查用户是否已登录，未登录则跳转到登录页
 */
function ProtectedRoute({ children }: { children: ReactNode }) {
  const { token } = useUserStore()

  if (!token) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

/**
 * 主布局组件
 *
 * 包含顶部导航、侧边栏和内容区域
 */
function MainLayout({ children }: { children: ReactNode }) {
  const { token } = useUserStore()
  const setMapCenter = useUIStore((state) => state.setMapCenter)

  // 应用启动时加载地图中心配置
  useEffect(() => {
    if (!token) return

    const loadMapCenter = async () => {
      try {
        const data = await get<{ lon: number; lat: number; zoom: number }>(
          '/api/v1/settings/map-center',
          { showError: false }
        )
        setMapCenter(data)
      } catch (error) {
        console.error('加载地图中心配置失败:', error)
      }
    }

    loadMapCenter()
  }, [token, setMapCenter])

  return (
    <Layout className="app-shell">
      <AppHeader />
      <Layout style={{ minHeight: 0 }}>
        <AppSider />
        <Content className="app-content">
          {children}
        </Content>
      </Layout>
    </Layout>
  )
}

/**
 * 低空监测系统主应用
 */
function App() {
  return (
    <BrowserRouter>
      <AppWebSocketManager />
      <Routes>
        {/* 登录页面（无需认证） */}
        <Route path="/login" element={<Login />} />

        {/* 受保护的路由 */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Navigate to="/monitor" replace />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* 实时监控页面 */}
        <Route
          path="/monitor"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Monitor />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/alarms"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AlarmCenter />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/videos"
          element={
            <ProtectedRoute>
              <MainLayout>
                <VideoManagement />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* TODO: 历史回放功能暂未完善，暂时禁用，访问时重定向到监控页 */}
        <Route
          path="/history"
          element={<Navigate to="/monitor" replace />}
        />

        {/* 系统设置页面 */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Settings />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* 未匹配的路由重定向到首页 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
